import React, { useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { setFieldError, setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputDate from 'apps/auth/components/form/InputDate';
import { CUSTOM_DATES_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { DATE_IN_FUTURE_ERROR, EMAIL_SCREEN, END_BEFORE_START_ERROR, MAX_STATEMENT_VALID_ERROR, START_AFTER_END_ERROR } from 'apps/auth/constants/Constants';
import { END_DATE_CAMELCASE, START_DATE_CAMELCASE } from 'apps/auth/constants/fieldsName';
import { TRANSFER_STATEMENT } from 'apps/auth/constants/formName';
import { getIsoDate, getIsoDateUSA } from 'apps/auth/helpers/utils';
import { useJsMessages, usePageMessages } from 'apps/auth/hooks/selectors';

const SelectPeriodScreen = (props) => {
    const { selectPeriodTitle, continueButton } = usePageMessages();
    const jsMessages = useJsMessages();
    const formName = TRANSFER_STATEMENT;

    const today = new Date();
    const todayMs = Date.parse(new Date());
    today.setFullYear(today.getFullYear() - 1);
    const oneYearAgo = today.getTime();
    const [startDateMs, setStartDateMs] = useState();
    const [endDateMs, setEndDateMs] = useState();

    const formHasErrors =
        props.fields?.[START_DATE_CAMELCASE]?.isError ||
        !props.fields?.[START_DATE_CAMELCASE]?.value ||
        props.fields?.[END_DATE_CAMELCASE]?.isError ||
        !props.fields?.[END_DATE_CAMELCASE]?.value;

    const onStartDateBlur = (value, name) => {
        let startDate = Date.parse(props.usaDateFormat ? getIsoDateUSA(value) : getIsoDate(value));
        if (value?.replace(/\D/g, '').length === 8) {
            if (startDate > todayMs) {
                props.setFieldError(formName, name, jsMessages[DATE_IN_FUTURE_ERROR]);
            } else if (endDateMs && startDate > endDateMs) {
                props.setFieldError(formName, name, jsMessages[START_AFTER_END_ERROR]);
            } else if (startDate < oneYearAgo) {
                props.setFieldError(formName, name, jsMessages[MAX_STATEMENT_VALID_ERROR]);
            }
        }
        setStartDateMs(startDate);
    };

    const onEndDateBlur = (value, name) => {
        let endDate = Date.parse(props.usaDateFormat ? getIsoDateUSA(value) : getIsoDate(value));
        if (value?.replace(/\D/g, '').length === 8) {
            if (endDate > todayMs) {
                props.setFieldError(formName, name, jsMessages[DATE_IN_FUTURE_ERROR]);
            } else if (startDateMs && endDate < startDateMs) {
                props.setFieldError(formName, name, jsMessages[END_BEFORE_START_ERROR]);
            } else if (endDate < oneYearAgo) {
                props.setFieldError(formName, name, jsMessages[MAX_STATEMENT_VALID_ERROR]);
            }
        }
        setEndDateMs(endDate);
    };

    return (
        <>
            <HeaderPanel title={selectPeriodTitle} />
            <Row indent="adaptive-32-48">
                <InputDate
                    field={props.fields?.[START_DATE_CAMELCASE]}
                    onBlurHandler={onStartDateBlur}
                    isClearErrorOnFocus={true}
                    formName={formName}
                    isNewInput
                    usaDateFormat={props.usaDateFormat}
                />
            </Row>
            <Row>
                <InputDate
                    field={props.fields?.[END_DATE_CAMELCASE]}
                    onBlurHandler={onEndDateBlur}
                    usaDateFormat={props.usaDateFormat}
                    isClearErrorOnFocus={true}
                    formName={formName}
                    isNewInput
                />
            </Row>
            <FixedBottomPanel isRightAligned buttonPosition={props.buttonPosition}>
                <Button
                    type="button"
                    raised={true}
                    onClick={() => {
                        amplitude.getInstance().logEvent(CUSTOM_DATES_CONTINUE_CLICKED);
                        props.switchToNextScreen(EMAIL_SCREEN);
                    }}
                    disabled={formHasErrors}
                    caption={continueButton}
                />
            </FixedBottomPanel>
        </>
    );
};

SelectPeriodScreen.propTypes = {
    fields: PropTypes.object.isRequired,
    switchToNextScreen: PropTypes.func.isRequired,
    usaDateFormat: PropTypes.bool,
};

export default connect(null, { setNewForm, setFieldError })(SelectPeriodScreen);
